import { Clock, VolumeX, Bot, Wrench } from "lucide-react";
import { useT } from "@/i18n/LangProvider";

const ICONS = [Clock, VolumeX, Bot, Wrench];

export default function Problems() {
  const { t } = useT();
  const cards = t("problems.cards") || [];

  return (
    <section
      id="problemas"
      data-testid="problems-section"
      className="section"
      style={{ background: "var(--navy-mid)" }}
    >
      <div className="section-inner">
        <p className="eyebrow fade-up">{t("problems.eyebrow")}</p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 mb-16 max-w-3xl fade-up">
          {t("problems.title1")}{" "}
          <em className="text-[color:var(--gold-light)]">
            {t("problems.title_em")}
          </em>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {cards.map((p, i) => {
            const Icon = ICONS[i] || Clock;
            return (
              <div
                key={p.title}
                className="card-navy fade-up"
                data-testid={`problem-card-${i}`}
              >
                <Icon
                  className="w-7 h-7 text-[color:var(--gold-light)] mb-5"
                  strokeWidth={1.4}
                />
                <h3 className="font-serif text-2xl md:text-3xl text-[color:var(--white)] mb-3">
                  {p.title}
                </h3>
                <p className="font-sans-brand text-[color:var(--muted-white)] leading-relaxed">
                  {p.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
